import WebFont from 'webfontloader';

import styled, { css, CSSObject, keyframes } from 'styled-components';
import { BaseBoxProps, ExtendedCSSProperties } from './type';

WebFont.load({
  google: {
    families: ['Poppins:300,400,500,600&display=swap'],
  },
});

const processBaseStyles = (sx?: ExtendedCSSProperties) => {
  const baseStyles: CSSObject = {};
  const pseudoStyles: Record<string, CSSObject> = {};
  if (sx)
    Object.entries(sx).forEach(([key, value]) => {
      if ((key.startsWith('::') || key.startsWith(':')) && value) {
        pseudoStyles[key] = value as CSSObject;
      } else {
        baseStyles[key] = value as CSSObject[keyof CSSObject];
      }
    });

  return { baseStyles, pseudoStyles };
};

const applyPseudoStyles = (pseudoStyles: Record<string, CSSObject>) => {
  return css`
    ${Object.entries(pseudoStyles).map(
      ([pseudo, styles]) => css`
        ${pseudo} {
          ${css(styles)}
        }
      `,
    )}
  `;
};

const applyKeyframes = (keyframesObj: ExtendedCSSProperties['@keyframes']) => {
  return keyframesObj
    ? Object.entries(keyframesObj).map(([keyframeName, keyframeStyles]) => {
        const keyframe = keyframes`${css(keyframeStyles as CSSObject)}`;
        return css`
          @keyframes ${keyframeName} {
            ${keyframe}
          }
        `;
      })
    : null;
};

const StyledBox = styled.div<BaseBoxProps>`
  ${({ sx }: { sx?: ExtendedCSSProperties }) => {
    const { baseStyles, pseudoStyles } = processBaseStyles(sx);
    return css`
      ${css(baseStyles)}
      ${applyPseudoStyles(pseudoStyles)}
      ${sx?.['@keyframes'] && applyKeyframes(sx['@keyframes'])}
    `;
  }}
  font-family: 'Poppins', sans-serif;
  font-weight: ${({ weight }) => {
    switch (weight) {
      case 'light':
        return 300;
      case 'normal':
        return 400;
      case 'semibold':
        return 500;
      case 'bold':
        return 600;
      default:
        return 400;
    }
  }};

  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  padding-left: ${({ paddingLeft }) => paddingLeft || '0'};
  padding-right: ${({ paddingRight }) => paddingRight || '0'};
  padding-top: ${({ paddingTop }) => paddingTop || '0'};
  padding-bottom: ${({ paddingBottom }) => paddingBottom || '0'};
`;

export default StyledBox;
